export default __webpack_public_path__ + "static/media/wi_6.d6ecc77d.mp3";